import{a as e}from"./chunk-6AAYEFVP.js";import{n as o,o as r}from"./chunk-5NG2JD2X.js";var f=new o({locale:[e,r]});export{f as a};
